export default __webpack_public_path__ + "static/media/bg-project.b504bfcc.png";